export class ProdutoIdadeSaque {
  public idadeMaxima!: number;
  public valorMaximo!: number;
  public fatorRMC!: number;
  public prazoMaximo!: number;
}